import type { FC } from 'react'
import React from 'react'
import Redirect from '@/router/components/Redirect'
import { ECommonRoute } from '@/types'

const Redirect404: FC = () => <Redirect url={ECommonRoute.error404} />

export default Redirect404
